import { createContext } from "react";
import type { AtlasCatalog } from "@/types/atlas";

/** Live catalog override; the Atlas route supplies its bundled fallback. */
export const AtlasCatalogContext = createContext<AtlasCatalog | undefined>(undefined);
